import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Dot, FolderFill, ThreeDotsVertical } from 'react-bootstrap-icons'
import axiosService from '../../../utils/AxiosService'
import { useNavigate, useParams } from 'react-router-dom'
import EditOptions from './EditOptions'
import ArchiveModal, { pluralize } from './ArchiveModal'
import { toastSuccess } from '../../FormComponents/Toasts'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function FoldersListItem({ folder }) {
  const { browseState, folders } = useContext(BrowseContext)
  const navigate = useNavigate()
  const [openEdit, setOpenEdit] = useState(false)
  const [archiveModalOpen, setArchiveModalOpen] = useState(false)
  const { client_id } = useParams()

  return (
    <div
      className='border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter bg-white dark:bg-rb-dark-mode p-2 rounded-lg flex justify-between items-center hover:cursor-pointer'
      onClick={() => navigate(`/project_manager/campaigns/clients/${folder.client_id}/folders/${folder.id}`)}
    >
      <div className="flex">
        <FolderFill className='p-3 rounded-lg text-5xl bg-gray-100 dark:bg-rb-dark-mode-lighter rb-text-muted' />
        <div className='pl-3'>
          <p className='flex items-center'><span className='rb-text-muted text-sm'>Folder</span><Dot className='text-lg rb-text-muted' /><span className='rb-text-muted text-sm'>{folder.client_name}</span></p>
          <h4 className='text-md font-bold dark:text-white'>{folder.name}</h4>
        </div>
      </div>
      <div className='flex gap-3 items-center'>
        <span className='h-10 w-10 rounded-full bg-rb-grey dark:bg-rb-dark-mode-lighter flex justify-center items-center dark:text-white'>
          <span>{folder.campaign_count}</span>
        </span>
        <span className='relative'>
          <button
            type='button'
            className='h-10 w-10 rounded-lg hover:bg-rb-grey dark:hover:bg-rb-dark-mode-lighter flex justify-center items-center dark:text-white'
            onClick={(e) => {
              e.stopPropagation()
              setOpenEdit(!openEdit)
            }}
          >
            <ThreeDotsVertical />
          </button>
          <EditOptions
            isOpen={openEdit}
            onClose={() => {
              setOpenEdit(false)
            }}
            onEdit={() => {
              console.log(folder)
              browseState.selectedFolder = folder
              browseState.toggleEditFolder()
            }}
            onDelete={() => {
              axiosService.delete(`/api/project_manager/folders/${folder.id}`)
                .then((removedFolder) => {
                  browseState.folders = folders.filter(folder => folder.id !== removedFolder.id )
                  browseState.adjustClientFolderCount(removedFolder.client_id, -1)
                  client_id ?
                    navigate(`/project_manager/campaigns/clients/${removedFolder.client_id}`) :
                    navigate('/project_manager/campaigns')

                  toastSuccess(`The Folder: '${removedFolder.name}' has been deleted!`)
                }).catch(err => console.log(err))
            }}
            onArchive={() => setArchiveModalOpen(true)}
          />
        </span>
        <span onClick={e => e.stopPropagation()}>
          <ArchiveModal
            isOpen={archiveModalOpen}
            onClose={() => setArchiveModalOpen(false)}
            title="Archive folder"
            name={folder.name}
            description={`Its ${pluralize(folder.campaign_count, 'campaign')} will be archived too. Restoring the folder restores its campaigns.`}
            onConfirm={() => browseState.archiveFolder(folder)}
          />
        </span>
      </div>
    </div>
  )
})
